import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetChangeRequestDetailDocument,
  type GetChangeRequestDetailQuery,
  type GetChangeRequestDetailQueryVariables,
} from "~/features/changeRequests/gqls";
import { useTenant } from "~/features/tenant/context";

/** Full detail for a single change request. */
export function useChangeRequestDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetChangeRequestDetailQuery, GetChangeRequestDetailQueryVariables>(
    GetChangeRequestDetailDocument,
    { variables: { tenantId, id } },
  );
}
